var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import ts, { factory } from "typescript";
import { createJsxElement, createFunctionalComponent } from '../../react-components/react-component-helper';
import { getProperties } from '../../entity/index';
import { MuiTableComponents } from '../../../definition/material-ui/table';
import { GrommetTableComponents } from '../../../definition/grommet/table';
import { Formatter, UiFramework } from "../../../definition/context-types";
import { uniqueImports } from "../../../ast/imports";
import { GeneratorHelper } from "../helper";
import ReactIntlFormatter from "../../react-components/react-intl/intl-formatter";
import { createAst, replaceElementsToAST } from "../../../../ast";
import { findWidgetParentNode } from "../../../ast/widgetDeclaration";
var BasicTableGenerator = /** @class */ (function () {
    function BasicTableGenerator(generationContext, entity, widgetContext) {
        this._imports = [];
        this._helper = new GeneratorHelper(generationContext, this._imports);
        this._context = generationContext;
        this._entity = entity;
        this._widgetContext = widgetContext;
        this._intlFormatter = new ReactIntlFormatter(generationContext, this._imports);
    }
    BasicTableGenerator.prototype.insertColumn = function (position, property, columnIndex) {
        return __awaiter(this, void 0, void 0, function () {
            var alteredSource, sourceCode, ast, widgetParentNode, tableDefinition, table, tableHead, tableBody, tableHeadRow, tableBodyRow, headColumns, bodyColumns, addHeaderColumn, addBodyColumn, rowComponent, headerRow, bodyRow;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        alteredSource = '';
                        if (!this._widgetContext) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._widgetContext.getSourceCodeString(position)];
                    case 1:
                        sourceCode = _a.sent();
                        ast = createAst(sourceCode);
                        if (ast) {
                            widgetParentNode = findWidgetParentNode(sourceCode, position);
                            if (widgetParentNode) {
                                tableDefinition = this.getTableDefinition();
                                table = this.findElementByName(widgetParentNode, tableDefinition.table.tagName.text);
                                if (table) {
                                    tableHead = this.findElementByName(table, tableDefinition.header.tagName.text);
                                    tableBody = this.findElementByName(table, tableDefinition.body.tagName.text);
                                    if (tableHead && tableBody) {
                                        tableHeadRow = this.findElementByName(tableHead, tableDefinition.row.tagName.text);
                                        tableBodyRow = this.findElementByName(tableBody, tableDefinition.row.tagName.text);
                                        if (tableHeadRow && tableBodyRow) {
                                            this._context.formatter = this.findUsedFormatter(ast);
                                            headColumns = [];
                                            bodyColumns = [];
                                            this.findElementsByName(tableHeadRow, tableDefinition.cell.tagName.text, headColumns);
                                            this.findElementsByName(tableBodyRow, tableDefinition.cell.tagName.text, bodyColumns);
                                            if (!this.tableBodyColumnExists(bodyColumns, property)) {
                                                addHeaderColumn = this.propertyHead(property, this._entity);
                                                addBodyColumn = this.propertyCell(property, this._entity);
                                                if (columnIndex && columnIndex > 0 && columnIndex < headColumns.length + 1) {
                                                    headColumns = __spreadArray(__spreadArray(__spreadArray([], headColumns.slice(0, columnIndex - 1)), [addHeaderColumn]), headColumns.slice(columnIndex - 1));
                                                    bodyColumns = __spreadArray(__spreadArray(__spreadArray([], bodyColumns.slice(0, columnIndex - 1)), [addBodyColumn]), bodyColumns.slice(columnIndex - 1));
                                                }
                                                else {
                                                    headColumns.push(addHeaderColumn);
                                                    bodyColumns.push(addBodyColumn);
                                                }
                                                rowComponent = this._helper.prepareComponent(this.getTableDefinition().row, this._imports);
                                                headerRow = createJsxElement(rowComponent.tagName, [], headColumns);
                                                bodyRow = createJsxElement(rowComponent.tagName, [], bodyColumns);
                                                ast = replaceElementsToAST(ast, tableHeadRow.pos, headerRow);
                                                ast = replaceElementsToAST(ast, tableBodyRow.pos, bodyRow);
                                                alteredSource = this.printSourceCode(ast);
                                                return [2 /*return*/, alteredSource];
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/, alteredSource];
                }
            });
        });
    };
    BasicTableGenerator.prototype.generateTableComponent = function () {
        if (this._entity) {
            var statements = this.createStatements();
            var functionalComponent = createFunctionalComponent(this._helper.getComponentName(this._entity), [this._helper.createInputParameter(this._entity)], statements);
            this._imports = __spreadArray(__spreadArray([], this._imports), this._intlFormatter.getImports());
            return { imports: uniqueImports(this._imports), functionDeclaration: functionalComponent };
        }
        return undefined;
    };
    BasicTableGenerator.prototype.createStatements = function () {
        var statements = new Array();
        var tableComponent = this._helper.prepareComponent(this.getTableDefinition().table, this._imports);
        var table = createJsxElement(tableComponent.tagName, [], [
            this.createHeader(),
            this.mapArrayToTableRows(this.createBodyRow())
        ]);
        var returnStatement = factory.createReturnStatement(table);
        statements.push(returnStatement);
        return statements;
    };
    BasicTableGenerator.prototype.createHeader = function () {
        var _this = this;
        var headerComponent = this._helper.prepareComponent(this.getTableDefinition().header, this._imports);
        var rowComponent = this._helper.prepareComponent(this.getTableDefinition().row, this._imports);
        var headerRow = createJsxElement(rowComponent.tagName, [], getProperties(this._entity)
            .map(function (prop) { return _this.propertyHead(prop, _this._entity); }));
        var tableHeader = createJsxElement(headerComponent.tagName, [], [headerRow]);
        return tableHeader;
    };
    BasicTableGenerator.prototype.createBodyRow = function () {
        var _this = this;
        var _a;
        var rowComponent = this._helper.prepareComponent(this.getTableDefinition().row, this._imports);
        var bodyRow = createJsxElement(rowComponent.tagName, [], (_a = getProperties(this._entity)) === null || _a === void 0 ? void 0 : _a.map(function (prop) { return _this.propertyCell(prop, _this._entity); }));
        return bodyRow;
    };
    BasicTableGenerator.prototype.getTableDefinition = function () {
        if (this._context.uiFramework === UiFramework.Grommet) {
            return GrommetTableComponents;
        }
        else if (this._context.uiFramework === UiFramework.MaterialUI) {
            return MuiTableComponents;
        }
        else {
            console.log('Unsupported ui framework for generation basic table');
            throw new Error('Unsupported ui framework for generation basic table');
        }
    };
    BasicTableGenerator.prototype.propertyHead = function (prop, entity) {
        var child = this._helper.getHeaderTitleJsxText(this._entity, prop);
        return createJsxElement(this._helper.prepareComponent(this.getTableDefinition().cell, this._imports).tagName, [], [child]);
    };
    BasicTableGenerator.prototype.propertyCell = function (prop, entity) {
        var child;
        if (this._context.formatter === Formatter.ReactIntl) {
            child = this.formatCellWithTag(prop);
        }
        else {
            child = factory.createJsxExpression(undefined, factory.createPropertyAccessExpression(this.getRowIdentifier(), factory.createIdentifier(prop.getName())));
        }
        return createJsxElement(this._helper.prepareComponent(this.getTableDefinition().cell, this._imports).tagName, [], [child]);
    };
    BasicTableGenerator.prototype.formatCellWithTag = function (prop) {
        var propertyAccess = factory.createJsxExpression(undefined, factory.createPropertyAccessExpression(this.getRowIdentifier(), factory.createIdentifier(prop.getName())));
        var formattedChild = this._intlFormatter.tryFormatPropertyUsingTag(prop, propertyAccess);
        var child;
        if (formattedChild) {
            child = formattedChild;
        }
        else {
            child = propertyAccess;
        }
        return child;
    };
    BasicTableGenerator.prototype.mapArrayToTableRows = function (body) {
        var bodyComponent = this._helper.prepareComponent(this.getTableDefinition().body, this._imports);
        return createJsxElement(bodyComponent.tagName, [], [factory.createJsxExpression(undefined, factory.createCallExpression(factory.createPropertyAccessExpression(this._helper.getInputParameterIdentifier(this._entity), factory.createIdentifier("map")), undefined, [factory.createArrowFunction(undefined, undefined, [factory.createParameterDeclaration(undefined, undefined, undefined, this.getRowIdentifier(), undefined, undefined, undefined)], undefined, factory.createToken(ts.SyntaxKind.EqualsGreaterThanToken), body)]))]);
    };
    BasicTableGenerator.prototype.getRowIdentifier = function () {
        return factory.createIdentifier(this._helper.getEntityName(this._entity));
    };
    BasicTableGenerator.prototype.printSourceCode = function (sourceFile) {
        var printer = ts.createPrinter({ newLine: ts.NewLineKind.LineFeed });
        return printer.printFile(sourceFile);
    };
    BasicTableGenerator.prototype.findElementByName = function (node, name) {
        var _this = this;
        if (node.kind === ts.SyntaxKind.JsxElement) {
            if (ts.isJsxElement(node)) {
                if (ts.isIdentifier(node.openingElement.tagName)) {
                    if (node.openingElement.tagName.escapedText === name) {
                        return node;
                    }
                }
            }
        }
        return node.forEachChild(function (child) {
            return _this.findElementByName(child, name);
        });
    };
    BasicTableGenerator.prototype.findElementsByName = function (node, name, output) {
        var _this = this;
        if (node.kind === ts.SyntaxKind.JsxElement) {
            if (ts.isJsxElement(node)) {
                if (ts.isIdentifier(node.openingElement.tagName)) {
                    if (node.openingElement.tagName.escapedText === name) {
                        output.push(node);
                    }
                }
            }
        }
        node.forEachChild(function (child) {
            _this.findElementsByName(child, name, output);
        });
    };
    BasicTableGenerator.prototype.findUsedFormatter = function (node) {
        var _a;
        var result = Formatter.None;
        var reactIntlImport = this.find(node.getSourceFile(), function (node) {
            if (ts.isImportDeclaration(node)) {
                if (ts.isStringLiteral(node.moduleSpecifier)) {
                    if (node.moduleSpecifier.text === 'react-intl') {
                        return true;
                    }
                }
            }
            return false;
        });
        if (reactIntlImport) {
            var importSpecifier = this.find(reactIntlImport, function (node) {
                if (ts.isImportSpecifier(node)) {
                    if (node.name.escapedText === 'FormattedMessage') {
                        return true;
                    }
                }
                return false;
            });
            if (importSpecifier) {
                var formattedMessageElementName = ((_a = importSpecifier.propertyName) === null || _a === void 0 ? void 0 : _a.escapedText) || importSpecifier.name.escapedText;
                var formattedMessageElement = this.find(node, function (node) {
                    if (ts.isJsxSelfClosingElement(node)) {
                        if (ts.isIdentifier(node.tagName)) {
                            if (node.tagName.escapedText === formattedMessageElementName) {
                                return true;
                            }
                        }
                    }
                    else if (ts.isJsxElement(node)) {
                        if (ts.isIdentifier(node.openingElement.tagName)) {
                            if (node.openingElement.tagName.escapedText === formattedMessageElementName) {
                                return true;
                            }
                        }
                    }
                    return false;
                });
                if (formattedMessageElement) {
                    result = Formatter.ReactIntl;
                }
            }
        }
        return result;
    };
    BasicTableGenerator.prototype.find = function (node, check) {
        var _this = this;
        if (check(node)) {
            return node;
        }
        ;
        return node.forEachChild(function (child) {
            return _this.find(child, check);
        });
    };
    BasicTableGenerator.prototype.findTableBodyColumnIds = function (nodes, output) {
        var _this = this;
        nodes.forEach(function (node) {
            if (ts.isJsxExpression(node)) {
                if (node.expression) {
                    if (ts.isPropertyAccessExpression(node.expression)) {
                        if (ts.isIdentifier(node.expression.name)) {
                            output.push(node.expression.name.escapedText.toString());
                        }
                    }
                }
            }
            node.forEachChild(function (child) {
                _this.findTableBodyColumnIds([child], output);
            });
        });
    };
    BasicTableGenerator.prototype.tableBodyColumnExists = function (tableBodyColumns, property) {
        var existsColumnIds = [];
        this.findTableBodyColumnIds(tableBodyColumns, existsColumnIds);
        return existsColumnIds.indexOf(property.getName()) > -1;
    };
    return BasicTableGenerator;
}());
export { BasicTableGenerator };
